import { TFunction } from 'react-i18next';
import { PriceKeys, PriceObject, PricesList } from 'types/api';

function formatOutputPrice(
  returnDiscount: boolean,
  validPrice: PriceObject,
  t: TFunction<'translation', undefined>
) {
  const baseValue =
    returnDiscount && validPrice?.discountInclVat
      ? validPrice.priceInclVat + validPrice.discountInclVat
      : validPrice?.priceInclVat;
  if (validPrice?.unit === '€/mnth')
    return t('common.eurPerMonth', {
      value: baseValue.toFixed(2).replaceAll('.', ','),
    });
  if (validPrice?.unit === 'NOK/months')
    return `${baseValue?.toFixed(2).replaceAll('.', ',') || ''} kr/mnd
  `;
  return `${baseValue?.toFixed(2).replaceAll('.', ',') || ''} ${
    validPrice?.unit || 'kr/mnd'
  }`;
}

export function getLastPriceObject(pricesList: PricesList) {
  const priceKeys = Object.keys(pricesList);
  const priceKeysLen = priceKeys.length;
  return pricesList[priceKeys[priceKeysLen - 1] as PriceKeys] as PriceObject;
}

export function getProperPriceString(
  priceObject: PriceObject | PricesList | undefined,
  t: TFunction<'translation', undefined>,
  returnDiscount = false
) {
  if (!priceObject) return '';

  if ('fee' in priceObject && priceObject.fee) {
    if ('energy' in priceObject && priceObject.energy) {
      return `${formatOutputPrice(
        returnDiscount,
        priceObject.fee,
        t
      )} + ${formatOutputPrice(returnDiscount, priceObject.energy, t)}`;
    }
    return formatOutputPrice(returnDiscount, priceObject.fee, t);
  }

  if ('priceInclVat' in priceObject)
    return formatOutputPrice(returnDiscount, priceObject, t);
  return '';
}

export function getAddonBasePriceValue(priceObject: PriceObject) {
  if (Array.isArray(priceObject)) return priceObject?.[1] || priceObject?.[0];
  return priceObject;
}

export function hasDiscount(priceObject?: PriceObject | PricesList) {
  if (!priceObject) return false;
  if ('discountInclVat' in priceObject && priceObject?.discountInclVat)
    return !!priceObject?.discountInclVat;
  return !!getLastPriceObject(priceObject as PricesList)?.discountInclVat;
}
